import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import Scheduler, { SchedulerData, ViewTypes, DATE_FORMAT } from "react-big-scheduler"; //include `react-big-scheduler/lib/css/style.css` for styles, link it in html or import it here

import "react-big-scheduler/lib/css/style.css";
import "./index.css";
import moment from "moment";
import { DragDropContext } from "react-dnd";
import Measure from "react-measure";
import HTML5Backend from "react-dnd-html5-backend";
import { Grid, Button } from "@material-ui/core";
import { AddResourceForm } from "./AddResource";
var defaultLocale = {
  dayMaxEvents: 10,
  weekMaxEvents: 100,
  monthMaxEvents: 100,
  yearMaxEvents: 100,
  resourceName: "Resources",
  taskName: "Tasks",
  agendaViewHeader: "Agenda",
  addMorePopoverHeaderFormat: "YYYY/MM dddd",
  eventItemPopoverDateFormat: "D MMM",
  nonAgendaDayCellHeaderFormat: "HH:mm",
  nonAgendaOtherCellHeaderFormat: "ddd|M/D",
  views: [{
    viewName: "Day",
    viewType: ViewTypes.Day,
    showAgenda: false,
    isEventPerspective: false
  }, {
    viewName: "Week",
    viewType: ViewTypes.Week,
    showAgenda: false,
    isEventPerspective: false
  }, {
    viewName: "Month",
    viewType: ViewTypes.Month,
    showAgenda: false,
    isEventPerspective: false
  }, {
    viewName: "Quarter",
    viewType: ViewTypes.Quarter,
    showAgenda: false,
    isEventPerspective: false
  }, {
    viewName: "Year",
    viewType: ViewTypes.Year,
    showAgenda: false,
    isEventPerspective: false
  }]
};

var ownLogicDayStart = function ownLogicDayStart(date, events) {
  var auxEventsToCheck = events.filter(function (event) {
    return event.start.includes(date);
  }).sort(function (event1, event2) {
    return event1.start < event2.start;
  }); // console.log("aux start", auxEventsToCheck, events, date);

  return auxEventsToCheck && auxEventsToCheck[0] ? moment(auxEventsToCheck[0].start).format("HH") || 0 : 0;
};

var ownLogicDayEnd = function ownLogicDayEnd(date, events) {
  var auxEventsToCheck = events.filter(function (event) {
    return event.end.includes(date);
  }).sort(function (event1, event2) {
    return event1.end > event2.end;
  });
  return auxEventsToCheck && auxEventsToCheck[0] ? moment(auxEventsToCheck[0].end).format("HH") || 23 : 23;
};

var isNonWorkingTime = function isNonWorkingTime(schedulerData, time) {
  // const { localeMoment } = schedulerData;
  // if (schedulerData.viewType === ViewTypes.Day) {
  //   let hour = localeMoment(time).hour();
  //   if (hour < 9 || hour > 18) return true;
  // } else {
  //   let dayOfWeek = localeMoment(time).weekday();
  //   if (dayOfWeek === 5 || dayOfWeek === 6) return true;
  // }
  return false;
};

var SchedulerComponent = /*#__PURE__*/function (_Component) {
  _inherits(SchedulerComponent, _Component);

  var _super = _createSuper(SchedulerComponent);

  function SchedulerComponent(props) {
    var _this;

    _classCallCheck(this, SchedulerComponent);

    _this = _super.call(this, props); //let schedulerData = new SchedulerData(new moment("2017-12-18").format(DATE_FORMAT), ViewTypes.Week);

    _this.prevClick = function (schedulerData) {
      var newDate = moment(_this.state.date).subtract(1, "days").format(DATE_FORMAT);

      if (_this.props.ownLogicDayStart) {
        schedulerData.config.dayStartFrom = ownLogicDayStart(newDate, _this.props.events);
      }

      if (_this.props.ownLogicDayEnd) {
        schedulerData.config.dayStopTo = ownLogicDayEnd(newDate, _this.props.events);
      }

      schedulerData.prev();
      schedulerData.setEvents(_this.props.events);

      _this.setState({
        viewModel: schedulerData,
        date: newDate
      });
    };

    _this.nextClick = function (schedulerData) {
      var newDate = moment(_this.state.date).add(1, "days").format(DATE_FORMAT);

      if (_this.props.ownLogicDayStart) {
        schedulerData.config.dayStartFrom = ownLogicDayStart(newDate, _this.props.events);
      }

      if (_this.props.ownLogicDayEnd) {
        schedulerData.config.dayStopTo = ownLogicDayEnd(newDate, _this.props.events);
      }

      schedulerData.next();
      schedulerData.setEvents(_this.props.events);

      _this.setState({
        viewModel: schedulerData,
        date: newDate
      });
    };

    _this.onViewChange = function (schedulerData, view) {
      schedulerData.setViewType(view.viewType, view.showAgenda, view.isEventPerspective);
      schedulerData.setEvents(_this.props.events);

      _this.setState({
        viewModel: schedulerData
      });
    };

    _this.onSelectDate = function (schedulerData, date) {
      var newDate = moment(date).format(DATE_FORMAT);

      if (_this.props.ownLogicDayStart) {
        schedulerData.config.dayStartFrom = ownLogicDayStart(newDate, _this.props.events);
      }

      if (_this.props.ownLogicDayEnd) {
        schedulerData.config.dayStopTo = ownLogicDayEnd(newDate, _this.props.events);
      }

      schedulerData.setDate(date);
      schedulerData.setEvents(_this.props.events);

      _this.setState({
        viewModel: schedulerData,
        date: newDate
      });
    };

    _this.eventClicked = function (schedulerData, event) {
      alert("You just clicked an event: {id: ".concat(event.id, ", title: ").concat(event.title, "}"));
    };

    _this.ops1 = function (schedulerData, event) {
      alert("You just executed ops1 to event: {id: ".concat(event.id, ", title: ").concat(event.title, "}"));
    };

    _this.ops2 = function (schedulerData, event) {
      alert("You just executed ops2 to event: {id: ".concat(event.id, ", title: ").concat(event.title, "}"));
    };

    _this.onScrollRight = function (schedulerData, schedulerContent, maxScrollLeft) {
      if (schedulerData.ViewTypes === ViewTypes.Day) {
        schedulerData.next();
        schedulerData.setEvents(_this.props.events);

        _this.setState({
          viewModel: schedulerData
        });

        schedulerContent.scrollLeft = maxScrollLeft - 10;
      }
    };

    _this.onScrollLeft = function (schedulerData, schedulerContent, maxScrollLeft) {
      if (schedulerData.ViewTypes === ViewTypes.Day) {
        schedulerData.prev();
        schedulerData.setEvents(_this.props.events);

        _this.setState({
          viewModel: schedulerData
        });

        schedulerContent.scrollLeft = 10;
      }
    };

    _this.onScrollTop = function (schedulerData, schedulerContent, maxScrollTop) {// console.log("onScrollTop");
    };

    _this.onScrollBottom = function (schedulerData, schedulerContent, maxScrollTop) {// console.log("onScrollBottom");
    };

    _this.toggleExpandFunc = function (schedulerData, slotId) {
      schedulerData.toggleExpandStatus(slotId);

      _this.setState({
        viewModel: schedulerData
      });
    };

    _this.updateEventStart = function (schedulerData, event, newStart) {
      schedulerData.updateEventStart(event, newStart);

      _this.setState({
        viewModel: schedulerData
      });
    };

    _this.updateEventEnd = function (schedulerData, event, newEnd) {
      schedulerData.updateEventEnd(event, newEnd);

      _this.setState({
        viewModel: schedulerData
      });
    };

    _this.moveEvent = function (schedulerData, event, slotId, slotName, start, end) {
      schedulerData.moveEvent(event, slotId, slotName, start, end);

      _this.setState({
        viewModel: schedulerData
      });
    };

    _this.handleModalAddResource = function () {
      var visibleModalAddResource = _this.state.visibleModalAddResource;

      _this.setState({
        visibleModalAddResource: !visibleModalAddResource
      });
    };

    _this.handleSubmitModalAddResource = function (data) {
      _this.props.handleSubmitModalAddResource(data).then(function (response) {})["catch"](function (err) {
        console.log(err);
      });
    };

    var _schedulerData = new SchedulerData(moment().format(DATE_FORMAT), ViewTypes.Day, false, false, _this.props.translation ? _this.props.translation.scheduler || defaultLocale : defaultLocale, {
      isNonWorkingTimeFunc: isNonWorkingTime
    }); //FIXME como poner idioma con moment automatico


    moment.locale("es");

    _schedulerData.setLocaleMoment(moment); // schedulerData.localeMoment.locale("es");


    if (_this.props.ownLogicDayStart) {
      _schedulerData.config.dayStartFrom = 0;

      var aux = _this.props.events.filter(function (event) {
        return event.start.includes(moment().format(DATE_FORMAT));
      }).sort(function (event1, event2) {
        return event1.start < event2.start;
      });
    }

    _schedulerData.setResources(_this.props.resources);

    _schedulerData.setEvents(_this.props.events); // schedulerData.config.schedulerWidth = window.screen.width;


    _this.state = {
      viewModel: _schedulerData,
      dimensions: {
        width: -1,
        height: -1
      },
      visibleModalAddResource: false,
      date: moment().format(DATE_FORMAT)
    };
    return _this;
  }

  _createClass(SchedulerComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var viewModel = this.state.viewModel; // console.log("viewModel config");

      viewModel.setEvents(this.props.events);
      viewModel.setResources(this.props.resources);
      viewModel.setLocaleMoment(moment);
      if (this.props.canChangeResourceName) viewModel.config.resourceName = this.props.translation ? this.props.translation.scheduler ? this.props.translation.scheduler.resourceName || "" : "" : "";
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.props.canAddResource && /*#__PURE__*/React.createElement(AddResourceForm, {
        open: this.state.visibleModalAddResource,
        onClose: this.handleModalAddResource,
        onSubmit: this.handleSubmitModalAddResource,
        translation: this.props.translation ? this.props.translation.scheduler ? this.props.translation.scheduler.dialog_translation || null : null : null
      }), /*#__PURE__*/React.createElement(Measure, {
        bounds: true,
        onResize: function onResize(dimensions) {
          _this2.setState({
            dimensions: dimensions.bounds
          });

          viewModel.config.schedulerWidth = _this2.state.dimensions.width;

          _this2.forceUpdate();
        }
      }, function (_ref) {
        var measureRef = _ref.measureRef;
        return /*#__PURE__*/React.createElement("div", {
          ref: measureRef
        }, /*#__PURE__*/React.createElement(Scheduler, {
          schedulerData: viewModel,
          prevClick: _this2.prevClick,
          nextClick: _this2.nextClick,
          onSelectDate: _this2.onSelectDate,
          onViewChange: _this2.onViewChange,
          eventItemClick: _this2.eventClicked //   viewEventClick={this.ops1}
          //   viewEventText="Ops 1"
          //   viewEvent2Text="Ops 2"
          //   viewEvent2Click={this.ops2}
          ,
          updateEventStart: _this2.updateEventStart,
          updateEventEnd: _this2.updateEventEnd //   moveEvent={this.moveEvent}
          //   newEvent={this.newEvent}
          ,
          onScrollLeft: _this2.onScrollLeft,
          onScrollRight: _this2.onScrollRight,
          onScrollTop: _this2.onScrollTop,
          onScrollBottom: _this2.onScrollBottom,
          toggleExpandFunc: _this2.toggleExpandFunc
        }));
      }), this.props.canAddResource && /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        style: {
          marginTop: "24px"
        },
        color: "primary",
        onClick: this.handleModalAddResource
      }, this.props.translation ? this.props.translation.buttons ? this.props.translation.buttons.add_resource || "Add resource" : "Add resource" : "Add resource"));
    }
  }]);

  return SchedulerComponent;
}(Component);

export default DragDropContext(HTML5Backend)(SchedulerComponent);